import { Transform } from 'class-transformer';
import { stringToBooleanNullable } from '../../types-transformers/boolean-transformers';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { OrderFilter } from '../../interfaces/filters/order.filter';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';
import { UserToPastEventDto } from '../../models/dto/past-event.dto';

export class PastEventAttendeesFilter implements PaginationFilter, OrderFilter<UserToPastEventDto> {
	/**
	 * when true, drafts are included to the response
	 */
	@Transform(stringToBooleanNullable)
	public isDraft?: boolean | null;

	public pageSize?: number | null;
	public page?: number | null;

	public orderedBy?: OrderParamPair<UserToPastEventDto>[] | null;
}
